import countries from "../components/checkout/countries"
import states from "../components/checkout/states"

export  let  getCountryValue = (label)=>{
    return countries.find(country=> country.label == label).value
}

export  let getCountryLabel = (value)=>{
    return countries.find(country=> country.value == value).label
}

export let getStateValue = (label)=>{
    return states.find(s=> s.name == label).abbreviation || label
}



// WEBPACK FOOTER //
// ./resources/js/store/countryHelper.js